import mod from "-!./logic.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./logic.js?vue&type=script&lang=js&external"